import { Box, CircularProgress } from "@mui/material";

export default function CenteredSpinner(){
    return (
        <Box sx={{width:'100%', height:'100%', display:'flex', justifycontent:'center', alignItems:'center'}}>
            <CircularProgress disableShrink sx={{width:'50px', height:'50px', margin:2}}/>
        </Box>
    )
}